import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
// ✅ ADD THIS — capture install prompt ASAP before React mounts
window.__deferredInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
});

const rootEl = document.getElementById("root");

// ✅ Replace with this
createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
//root.render(
//  <React.StrictMode>
//  <App />
//</React.StrictMode>,
//);
// Register PWA Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => console.log("✅ PWA Ready!"))
      .catch((error) => console.log("❌ PWA Error:", error));
  });
}
